<template>
  <el-dialog title="归还资产"
             :visible.sync="detailShow"
             v-dialogDrag>
    <div class="detail_code">
      <span>单号：{{collectionCode}}</span>
    </div>
    <div class="detail_list">
      <h4>资产列表</h4>
      <ioc-table ref="crud"
                 v-model="detailList"
                 :data="detailData"
                 :option="option"
                 :page="false">
      </ioc-table>
    </div>
  </el-dialog>
</template>

<script>
import { api } from "../api";
import tableOption from '../const/detailOption'
import utils from '@src/common/utils'
export default {
  props: {
  },
  data () {
    return {
      collectionCode: '',
      detailShow: false,
      detailList: {},
      detailData: [],
      option: tableOption(this),
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10
      },
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    open (collectionCode) {
      this.detailShow = true
      this.collectionCode = collectionCode
      if (collectionCode) {
        this.getDetailList()
      }
    },
    getDetailList () {
      const params = {
        collectionCode: this.collectionCode
      }
      this.$fetch(api.assetsManage.assetsClaimedDetails, params).then(res => {
        if (res && res.success) {
          this.detailData = res.returnObj
        } else {
          this.$message.error(res.msgContent)
        }
      })
    }
  }
}
</script>
<style lang="scss">
@import "../style/recipient.scss";
</style>
